"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonSlots = exports.default = exports.Button = void 0;
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _utils = require("../utils");
var _buttonClasses = require("./buttonClasses");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable complexity -- it is a big and complex component :P */

const getButtonSlots = ownerState => {
  const {
    color,
    fullWidth,
    size,
    variant,
    loading,
    loadingPosition
  } = ownerState;
  return {
    root: ['root', loading && 'loading', variant, `size${(0, _utils.capitalize)(size)}`, `color${(0, _utils.capitalize)(color)}`, fullWidth && 'fullWidth', loading && `loadingPosition${(0, _utils.capitalize)(loadingPosition)}`],
    startIcon: ['icon', 'startIcon', `iconSize${(0, _utils.capitalize)(size)}`],
    endIcon: ['icon', 'endIcon', `iconSize${(0, _utils.capitalize)(size)}`],
    loadingIndicator: ['loadingIndicator'],
    loadingWrapper: ['loadingWrapper']
  };
};
exports.getButtonSlots = getButtonSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getButtonSlots(ownerState);
  const composedClasses = (0, _base.unstable_composeClasses)(slots, _buttonClasses.getButtonUtilityClass, classes);
  return {
    ...classes,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...composedClasses
  };
};
const ButtonRoot = (0, _material.styled)(_material.ButtonBase, {
  shouldForwardProp: prop => (0, _utils.rootShouldForwardProp)(prop) || prop === 'classes',
  name: 'MuiOriButton',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.root, styles[ownerState.variant], styles[`color${(0, _utils.capitalize)(ownerState.color)}`], styles[`size${(0, _utils.capitalize)(ownerState.size)}`], ownerState.fullWidth && styles.fullWidth, ownerState.loading && styles.loading, ownerState.loading && styles[`loadingPosition${(0, _utils.capitalize)(ownerState.loadingPosition)}`]]
})(({
  theme,
  ownerState
}) => ({
  ...theme.typography.button,
  minWidth: ownerState.minWidth,
  borderRadius: 25,
  border: 0,
  width: 'max-content',
  height: 'max-content',
  maxWidth: ownerState.maxWidth ?? '100%',
  ...(ownerState.commonButton && {
    maxWidth: 500,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '100%',
      minWidth: 330,
      width: 'max-content'
    }
  }),
  ...(ownerState.size === 'small' && {
    padding: '4px 12px',
    fontSize: '1.3rem',
    minHeight: 30
  }),
  ...(ownerState.size === 'medium' && {
    padding: '10px 20px',
    minHeight: 45
  }),
  transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color', 'color'], {
    duration: theme.transitions.duration.short
  }),
  '&:hover': {
    textDecoration: 'none'
  },
  ...(ownerState.variant === 'contained' && {
    color: theme.palette.default.contrastText,
    background: theme.palette.default.dark,
    boxShadow: 'none',
    '&:hover': {
      color: theme.palette.default.contrastText,
      background: theme.palette.grey.A700,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        background: theme.palette.default.dark
      }
    },
    '&:focus': {
      color: theme.palette.default.contrastText
    },
    '&:active': {
      boxShadow: theme.shadows[8]
    },
    ...(ownerState.disableFocusRipple && {
      '&:focus-visible': {
        color: theme.palette.default.contrastText,
        outline: `2px solid ${theme.palette.common.white}`,
        outlineOffset: -4
      }
    }),
    ...(ownerState.color === 'error' && {
      color: theme.palette.error.contrastText,
      background: theme.palette.error.main,
      '&:hover': {
        color: theme.palette.error.contrastText,
        background: theme.palette.error.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          background: theme.palette.error.main
        }
      },
      '&:focus': {
        color: theme.palette.error.contrastText
      }
    }),
    ...((ownerState.disabled || ownerState.loading) && {
      background: theme.palette.grey[200],
      color: theme.palette.grey.A400
    }),
    ...(ownerState.color === 'default' && {
      color: theme.palette.default.main,
      background: theme.palette.default.contrastText,
      boxShadow: theme.shadows[2],
      '&:hover': {
        color: theme.palette.default.main,
        background: theme.palette.default.contrastText,
        boxShadow: theme.shadows[3],
        '@media (hover: none)': {
          boxShadow: theme.shadows[2],
          background: theme.palette.default.contrastText
        }
      },
      '&:focus': {
        color: theme.palette.default.main
      },
      '&:focus-visible': {
        color: theme.palette.default.main,
        boxShadow: theme.shadows[6]
      },
      ...((ownerState.disabled || ownerState.loading) && {
        color: theme.palette.grey[400],
        background: theme.palette.default.contrastText,
        boxShadow: theme.shadows[2]
      })
    })
  }),
  ...(ownerState.variant === 'outlined' && {
    border: '1px solid currentColor',
    borderColor: theme.palette.default.dark,
    color: theme.palette.default.dark,
    background: 'transparent',
    '&:hover': {
      color: theme.palette.default.dark,
      background: (0, _material.alpha)(theme.palette.default.main, 0.12),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        background: 'transparent'
      }
    },
    '&:focus': {
      color: theme.palette.default.dark
    },
    '&:active': {
      background: (0, _material.alpha)(theme.palette.default.main, 0.12)
    },
    ...(ownerState.color === 'inherit' && {
      color: 'inherit',
      borderColor: 'currentColor',
      '&:hover': {
        color: theme.palette.common.white,
        background: theme.palette.grey.A700,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          color: 'inherit',
          background: 'transparent'
        }
      },
      '&:active': {
        color: theme.palette.common.white,
        background: theme.palette.grey.A700
      }
    }),
    ...(ownerState.color === 'error' && {
      borderColor: theme.palette.error.dark,
      color: theme.palette.error.dark,
      '&:hover': {
        color: theme.palette.error.dark,
        background: (0, _material.alpha)(theme.palette.error.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          background: 'transparent'
        }
      },
      '&:focus': {
        color: theme.palette.error.dark
      },
      '&:active': {
        background: (0, _material.alpha)(theme.palette.error.main, theme.palette.action.hoverOpacity)
      }
    }),
    ...(ownerState.size === 'small' && {
      padding: '3px 11px'
    }),
    ...(ownerState.size === 'medium' && {
      padding: '9px 19px'
    }),
    ...((ownerState.disabled || ownerState.loading) && {
      background: theme.palette.grey[200],
      color: theme.palette.grey.A400,
      borderColor: theme.palette.grey[200]
    }),
    ...(ownerState.disableFocusRipple && {
      '&:focus-visible': {
        outline: `2px solid ${theme.palette.default.dark}`,
        outlineOffset: -2,
        backgroundColor: (0, _material.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
      }
    })
  }),
  ...(ownerState.variant === 'text' && {
    padding: '6px 8px',
    color: theme.palette.default.dark,
    backgroundColor: 'transparent',
    '&:hover': {
      color: theme.palette.default.dark,
      background: (0, _material.alpha)(theme.palette.default.main, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        background: 'transparent'
      }
    },
    '&:focus': {
      color: theme.palette.default.dark
    },
    '&:active': {
      background: (0, _material.alpha)(theme.palette.default.main, theme.palette.action.hoverOpacity)
    },
    ...(ownerState.color === 'error' && {
      color: theme.palette.error.main,
      '&:hover': {
        color: theme.palette.error.main,
        background: (0, _material.alpha)(theme.palette.error.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          background: 'transparent'
        }
      },
      '&:focus': {
        color: theme.palette.error.main
      },
      '&:active': {
        background: (0, _material.alpha)(theme.palette.error.main, theme.palette.action.hoverOpacity)
      }
    }),
    ...(ownerState.color === 'inherit' && {
      color: 'inherit',
      '&:hover': {
        color: theme.palette.common.white,
        background: theme.palette.grey.A700,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          color: 'inherit',
          background: 'transparent'
        }
      },
      '&:active': {
        color: theme.palette.common.white,
        background: theme.palette.grey.A700
      }
    }),
    ...(ownerState.size === 'small' && {
      borderRadius: 5,
      padding: '1px 5px',
      fontSize: '1.3rem',
      minHeight: 24,
      ...(ownerState.disableUppercase && {
        textTransform: 'none'
      })
    }),
    ...(ownerState.size === 'medium' && {
      padding: '10px 10px'
    }),
    ...((ownerState.disabled || ownerState.loading) && {
      background: 'transparent',
      color: theme.palette.grey.A400
    }),
    ...(ownerState.disableFocusRipple && {
      '&:focus-visible': {
        outline: `1px solid ${theme.palette.default.dark}`,
        outlineOffset: -1
      }
    })
  }),
  ...(ownerState.fullWidth && {
    width: '100%'
  }),
  ...(ownerState.loadingPosition === 'center' && {
    transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color'], {
      duration: theme.transitions.duration.short
    }),
    ...(ownerState.loading && {
      color: 'transparent'
    })
  })
}));
const ButtonStartIcon = (0, _material.styled)('span', {
  name: 'MuiOriButton',
  slot: 'StartIcon',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.startIcon, ownerState.loading && styles.loading, styles[`iconSize${(0, _utils.capitalize)(ownerState.size)}`]]
})(({
  theme,
  ownerState
}) => ({
  display: 'inherit',
  marginRight: 8,
  marginLeft: -4,
  ...(ownerState.size === 'small' && {
    marginRight: 5,
    marginLeft: -2,
    '& > *:nth-of-type(1)': {
      fontSize: '1.8rem'
    }
  }),
  ...(ownerState.size === 'medium' && {
    '& > *:nth-of-type(1)': {
      fontSize: '2rem'
    }
  }),
  ...(ownerState.loadingPosition === 'start' && ownerState.loading && {
    transition: theme.transitions.create(['opacity'], {
      duration: theme.transitions.duration.short
    }),
    opacity: 0
  })
}));
const ButtonEndIcon = (0, _material.styled)('span', {
  name: 'MuiOriButton',
  slot: 'EndIcon',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.endIcon, ownerState.loading && styles.loading, styles[`iconSize${(0, _utils.capitalize)(ownerState.size)}`]]
})(({
  theme,
  ownerState
}) => ({
  display: 'inherit',
  marginLeft: 8,
  marginRight: -4,
  ...(ownerState.size === 'small' && {
    marginLeft: 5,
    marginRight: -2,
    '& > *:nth-of-type(1)': {
      fontSize: '1.8rem'
    }
  }),
  ...(ownerState.size === 'medium' && {
    '& > *:nth-of-type(1)': {
      fontSize: '2rem'
    }
  }),
  ...(ownerState.loadingPosition === 'end' && ownerState.loading && {
    transition: theme.transitions.create(['opacity'], {
      duration: theme.transitions.duration.short
    }),
    opacity: 0
  }),
  ...(ownerState.loadingPosition === 'end' && ownerState.loading && ownerState.fullWidth && {
    marginLeft: -8
  })
}));
const ButtonLoadingIndicator = (0, _material.styled)('span', {
  name: 'MuiOriButton',
  slot: 'LoadingIndicator',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.loadingIndicator]
})(({
  theme,
  ownerState
}) => ({
  display: 'none',
  position: 'absolute',
  visibility: 'visible',
  ...(ownerState.loading && {
    display: 'flex'
  }),
  ...(ownerState.loadingPosition === 'start' && {
    left: 14,
    ...(ownerState.size === 'small' && {
      left: 10
    }),
    ...(ownerState.variant === 'text' && {
      left: 6
    })
  }),
  ...(ownerState.loadingPosition === 'center' && {
    left: '50%',
    transform: 'translate(-50%)',
    color: theme.palette.action.disabled
  }),
  ...(ownerState.loadingPosition === 'end' && {
    right: 14,
    ...(ownerState.size === 'small' && {
      right: 10
    }),
    ...(ownerState.variant === 'text' && {
      right: 6
    })
  })
}));
const ButtonLoadingIconPlaceholder = (0, _material.styled)('span', {
  name: 'MuiOriButton',
  slot: 'LoadingIconPlaceholder',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.loadingIconPlaceholder]
})(({
  theme,
  ownerState
}) => ({
  display: 'inline-block',
  width: '1em',
  height: '1em'
}));
const Button = exports.Button = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _material.useThemeProps)({
    props: inProps,
    name: 'MuiOriButton'
  });
  const {
    children,
    color = 'default',
    className,
    dataTestId,
    disabled = false,
    disableFocusRipple = false,
    disableUppercase = false,
    endIcon: endIconProp,
    focusVisibleClassName,
    fullWidth = false,
    id: idProp,
    loading = null,
    loadingIndicator: loadingIndicatorProp,
    loadingPosition = 'center',
    maxWidth,
    minWidth = '24px',
    size = 'medium',
    startIcon: startIconProp,
    type,
    variant = 'text',
    ...other
  } = props;
  const loadingId = (0, _material.unstable_useId)(idProp);
  const loaderSize = (0, _react.useMemo)(() => {
    if (variant === 'text' && size === 'small') {
      return '1.6rem';
    }
    if (size === 'small') {
      return '1.8rem';
    }
    return '2rem';
  }, [size, variant]);
  const loadingIndicator = (0, _react.useMemo)(() => loadingIndicatorProp ?? /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.CircularProgress, {
    "aria-labelledby": loadingId,
    color: "inherit",
    size: loaderSize
  }), [loadingIndicatorProp, loadingId, loaderSize]);
  const ownerState = (0, _react.useMemo)(() => ({
    ...props,
    color,
    disabled,
    disableFocusRipple,
    disableUppercase,
    fullWidth,
    loading,
    loadingIndicator,
    loadingPosition,
    maxWidth,
    minWidth,
    size,
    type,
    variant
  }), [props, color, disabled, disableFocusRipple, disableUppercase, fullWidth, loading, loadingIndicator, loadingPosition, maxWidth, minWidth, size, type, variant]);
  const classes = useUtilityClasses(ownerState);
  const startIcon = (0, _react.useMemo)(() => {
    if (loading && loadingPosition === 'start') {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonLoadingIconPlaceholder, {
          className: classes.loadingIconPlaceholder,
          ownerState: ownerState
        })
      });
    }
    if (startIconProp !== null && startIconProp !== undefined) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
      });
    }
    return null;
  }, [loading, loadingPosition, startIconProp, classes.startIcon, classes.loadingIconPlaceholder, ownerState]);
  const endIcon = (0, _react.useMemo)(() => {
    if (loading && loadingPosition === 'end') {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonLoadingIconPlaceholder, {
          className: classes.loadingIconPlaceholder,
          ownerState: ownerState
        })
      });
    }
    if (endIconProp !== null && endIconProp !== undefined) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
      });
    }
    return null;
  }, [loading, loadingPosition, endIconProp, classes.endIcon, classes.loadingIconPlaceholder, ownerState]);
  const loader = (0, _react.useMemo)(() => {
    if (typeof loading === 'boolean') {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
          display: 'contents'
        },
        children: loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonLoadingIndicator, {
          className: classes.loadingIndicator,
          ownerState: ownerState,
          children: loadingIndicator
        }) : null
      });
    }
    return null;
  }, [classes.loadingIndicator, classes.loadingWrapper, loading, loadingIndicator, ownerState]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(ButtonRoot, {
    ref: ref,
    ownerState: ownerState,
    className: (0, _clsx.default)(classes.root, className),
    disabled: disabled || (loading ?? false),
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName),
    type: type,
    id: loading ? loadingId : idProp,
    "data-testid": dataTestId,
    ...other,
    children: [startIcon, loadingPosition !== 'end' && loader, children, loadingPosition === 'end' && loader, endIcon]
  });
});
var _default = exports.default = Button;
//# sourceMappingURL=Button.js.map